<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <circle
      cx="12"
      cy="12"
      fill="#F8FCFC"
      r="12"
    />
    <path
      d="M12.0001 4.11328C9.5477 4.11328 7.54297 6.11801 7.54297 8.57042C7.54297 11.0228 9.5477 13.0276 12.0001 13.0276C14.4525 13.0276 16.4573 11.0228 16.4573 8.57042C16.4573 6.11801 14.4525 4.11328 12.0001 4.11328Z"
      fill="#E6E7E9"
    />
    <path
      d="M20.534 16.6731C20.4037 16.3451 20.23 16.0389 20.0345 15.7546C19.0357 14.2675 17.4941 13.2834 15.757 13.0428C15.5399 13.0209 15.301 13.0646 15.1273 13.1959C14.2153 13.8738 13.1296 14.2237 12.0005 14.2237C10.8714 14.2237 9.78571 13.8738 8.87373 13.1959C8.7 13.0646 8.46115 12.9991 8.24403 13.0428C6.50694 13.2834 4.94357 14.2675 3.96646 15.7546C3.77104 16.0389 3.59732 16.3669 3.46706 16.6731C3.40194 16.8043 3.42363 16.9574 3.48876 17.0886C3.66248 17.3948 3.8796 17.701 4.07502 17.9634C4.379 18.3789 4.70472 18.7507 5.07386 19.1006C5.37784 19.4068 5.72525 19.6911 6.07271 19.9754C7.78806 21.2657 9.85087 21.9436 11.9788 21.9436C14.1067 21.9436 16.1696 21.2656 17.8849 19.9754C18.2323 19.713 18.5797 19.4068 18.8838 19.1006C19.2312 18.7507 19.5786 18.3789 19.8826 17.9634C20.0997 17.6791 20.2952 17.3948 20.4689 17.0886C20.5774 16.9574 20.5991 16.8043 20.534 16.6731Z"
      fill="#E6E7E9"
    />
  </svg>
</template>

<script>
export default {
  name: 'WhiteUserIcon24'
};
</script>

<style scoped>

</style>
